import { jsx } from 'react/jsx-runtime';

/** ![italicIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNMTkgNGgtOU0xNCAyMEg1TTE1IDQgOSAyMCIvPjwvc3ZnPg==) */
const italicIcon = /*#__PURE__*/jsx("path", {
  d: "M19 4h-9M14 20H5M15 4 9 20"
});

export { italicIcon };
